$(document).ready(function() {
  $('.product-slider-container').slick({
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    responsive: [{
        breakpoint: 1440,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          autoplay: false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          arrows: false,
        }
      }
    ]
  });
});

// destroy the slider and convert all slides into a single column with this (change breakpoint as needed):
// {
//   breakpoint: 576,
//   settings: "unslick"
// }